export const simCardType = {
  simType4G: '3IN1',
  simType5G: '5G3IN1',
  simTypeESim: 'eSIM5GPost'
};
